import React, { useEffect, useState } from 'react';

import AccountActionsMenu from 'components-core/Navbar/Fragments/AccountActionsMenu';
import { Header, Logo } from './PanelHeaderStyles';
import AccountServices from '../../../modules/account/services/AccountServices';

const PanelHeader = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    setIsAuthenticated(AccountServices.isAuthenticated());
  }, []);

  return (
    <Header>
      <Logo />
      {isAuthenticated ? <AccountActionsMenu /> : null}
    </Header>
  );
};

export default PanelHeader;
